import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CartOutlets } from '@spartacus/cart/base/root';
import { FeaturesConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { GenCartItemListComponent } from './cart-item-list/cart-item-list.component';
import { SpartacusCartItemComponent } from './cart-item/cart-item.component';
import { AtMessageModule, IconModule, ItemCounterModule, MediaModule, OutletModule, PromotionsModule, provideOutlet, SpinnerModule } from '@spartacus/storefront';
import { GenSharedModule } from "../../../../generac/shared/shared.module";
import { GenCartItemComponent } from './gen-cart-item/cart-item.component';
import { GenSubscriptionsTableComponent } from './subscriptions-table/subscriptions-table.component';
import { GenSpIconsComponent } from 'src/app/generac/shared/components/sp-icons/sp-icons.component';
import { SafeModule } from 'src/app/generac/shared/pipes/safe/safe.module';
import { GenCartItemListRowComponent } from './cart-item-list-row/cart-item-list-row.component';
import { GenCartItemValidationWarningModule } from '../cart-item-warning/cart-item-validation-warning.module';
import { GenNoReturnWarningComponent } from '../../product/no-return-warning/no-return-warning.component';
import { GenItemCounterComponent } from 'src/app/generac/shared/components/item-counter/item-counter.component';
import { GenSppConsumerDetailsFormComponent } from '../spp-consumer-details-form/spp-consumer-details-form.component';

@NgModule({
  imports: [
    GenCartItemValidationWarningModule,
    AtMessageModule,
    CommonModule,
    FeaturesConfigModule,
    I18nModule,
    IconModule,
    ItemCounterModule,
    MediaModule,
    OutletModule,
    GenItemCounterComponent,
    PromotionsModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    SpinnerModule,
    GenSharedModule,
    GenNoReturnWarningComponent,
    GenSpIconsComponent,
    SafeModule,
    GenSppConsumerDetailsFormComponent,
  ],
  providers: [
    provideOutlet({
      id: CartOutlets.CART_ITEM_LIST,
      component: GenCartItemListComponent,
    })
  ],
  declarations: [
    SpartacusCartItemComponent,
    GenCartItemListComponent,
    GenCartItemListRowComponent,
    GenCartItemComponent,
    GenSubscriptionsTableComponent,
  ],
  exports: [
    SpartacusCartItemComponent,
    GenCartItemListComponent,
    GenCartItemListRowComponent,
    GenCartItemComponent,
    GenSubscriptionsTableComponent,
  ],
})
export class GenCartSharedModule {}
